import { createRoute } from '@tanstack/react-router';
import { Route as shellRoute } from './_shell';
import { useSession } from '@/app/session';
import { HealthStrip } from '@/features/home/HealthStrip';
import { ActionInbox } from '@/features/home/ActionInbox';
import { TodayTiles } from '@/features/home/TodayTiles';
import { QueueButtons } from '@/features/home/QueueButtons';
import { Money30d } from '@/features/home/Money30d';
import { StockAtRisk } from '@/features/home/StockAtRisk';
import { CashForecast } from '@/features/home/CashForecast';

/**
 * Home. Health first, then work, then numbers.
 *
 * The card order is fixed and there is no widget picker: health strip, Action Inbox, Today,
 * fulfillment queues, Money 30d, Stock at risk, Cash forecast. A packer sees the ops subset,
 * which is the same page with the two money cards absent. That absence is not cosmetic: the
 * server never sends those metric ids to that role.
 *
 * There are no charts here. A chart cannot be read in five seconds.
 */
function Home() {
  const { can, canAny, role } = useSession();
  const showMoney = can('metrics.read_money');
  const showStock = canAny('stock.read', 'stock.read_packer');
  const showQueues = canAny('orders.read', 'orders.read_packer', 'orders.read_agent');
  const showFinance = can('finance.read');

  return (
    <>
      {can('health.read') ? <HealthStrip /> : null}
      {can('inbox.read') ? <ActionInbox /> : null}
      <TodayTiles />
      {showQueues ? <QueueButtons /> : null}
      {showMoney ? <Money30d /> : null}
      {showStock ? <StockAtRisk /> : null}
      {showFinance ? <CashForecast /> : null}
      {role === 'packer' ? (
        <p className="o-notice">
          Packing view. Prices, totals and customer contact details are not sent to this role
          at all, so nothing here is hidden from you by the screen; it simply is not in the
          response.
        </p>
      ) : null}
    </>
  );
}

export const Route = createRoute({
  getParentRoute: () => shellRoute,
  path: '/',
  component: Home,
});
